// frontend/src/pages/SyncLogs.js
import React, { useState, useEffect } from 'react';
import { api } from '../App';

export default function SyncLogs() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get('/sync/logs').then(r => setLogs(r.data)); }, []);

  return (
    <div>
      <div className="page-header">
        <div className="page-title">🔄 Sync Logs</div>
        <button className="btn btn-ghost" onClick={() => api.get('/sync/logs').then(r => setLogs(r.data))}>Refresh</button>
      </div>
      <div className="card">
        <div className="table-wrap">
          <table>
            <thead><tr><th>Job</th><th>Channel</th><th>Status</th><th>Records</th><th>Duration</th><th>Started</th><th>Message</th></tr></thead>
            <tbody>
              {logs.map(l => {
                const dur = l.finished_at && l.started_at
                  ? Math.round((new Date(l.finished_at) - new Date(l.started_at)) / 1000) + 's'
                  : l.status === 'running' ? '⏳' : '—';
                return (
                  <tr key={l.id}>
                    <td style={{ fontSize:13 }}>{l.job_name}</td>
                    <td className="text-muted" style={{ fontSize:12 }}>{l.channel}</td>
                    <td><span className={`badge ${l.status==='success'?'badge-active':l.status==='error'?'badge-error':'badge-pending'}`}>{l.status}</span></td>
                    <td>{l.records}</td>
                    <td className="text-muted" style={{ fontSize:12 }}>{dur}</td>
                    <td className="text-muted" style={{ fontSize:12 }}>{l.started_at ? new Date(l.started_at).toLocaleString() : ''}</td>
                    <td style={{ fontSize:11, color:'var(--danger)', maxWidth:200, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{l.message || ''}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
